
import {
  useCac,
  useLeads,
  useRelatorio,
  useSerieHistorica,
  type FiltroPeriodo,
} from './api/relatorio-api'
import { PainelDenso } from './painel-denso'

import type { ReactElement } from 'react'

import { AvisoDesconectado } from '@/components/shared/aviso-desconectado'
import { ApresentacaoCarregando } from '@/features/apresentacao/apresentacao-carregando'

/** O painel comercial denso buscando os próprios dados para a apresentação global. */
export function BlocoComercialDenso({ periodo }: { periodo: FiltroPeriodo }): ReactElement {
  const { data: relatorio } = useRelatorio(periodo)
  const { data: serie } = useSerieHistorica(12)
  const { data: cac } = useCac(periodo)
  const { data: leads } = useLeads(periodo)

  if (!relatorio) return <ApresentacaoCarregando titulo="Comercial" />

  // No telao, zeros pareceriam resultado: melhor dizer que a fonte esta fora.
  // `=== false`: payload de cache antigo (sem o campo) nao pode virar aviso.
  if (relatorio.disponivel === false) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <p className="text-lg font-medium">Comercial indisponível</p>
        <p className="text-muted-foreground text-base">
          {relatorio.motivo || 'Integração do HubSpot fora do ar.'}
        </p>
      </div>
    )
  }

  return (
    <div className="flex h-full flex-col gap-3">
      {/* Fonte fora com snapshot: o telao mostra os numeros com a data em cima,
          senao a plateia leria dado velho como o de agora. */}
      {relatorio.desatualizado ? (
        <AvisoDesconectado
          fonte="HubSpot"
          motivo={relatorio.motivo}
          coletadoEm={relatorio.coletadoEm}
        />
      ) : null}
      <div className="min-h-0 flex-1">
        <PainelDenso relatorio={relatorio} serie={serie} cac={cac} leads={leads} />
      </div>
    </div>
  )
}
